import { Box, Button, Typography } from "@mui/material";
import { setRejectModalOpen } from "../../store/job/jobSlice";
import { useDispatch } from "react-redux";

const ProofFooter = ({ proof_data, onApprove, onReject, is_reject_modal_open, reject_comment }) => {
  const dispatch = useDispatch();
  const allApproved = proof_data?.every(item => item.sent_approved_files === 2);
  const allRejected = proof_data?.every(item => item.sent_approved_files === 3);

  return (
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", position: "relative", mt: 2, mb: 2, pr: "20px", py: 1 }}>
      {/* <Typography variant="h6" sx={{ fontWeight: 600, fontFamily: "'Inter Tight', sans-serif" }}>
        Proof Approval
      </Typography> */}
      <Box sx={{ position: "absolute", right: "20px", top: "50%", transform: "translateY(-50%)", display: "flex", alignItems: "center" }}>
        {allApproved ? (
          <Typography variant="subtitle1" color="success.main">
            Already Approved
          </Typography>
        ) : allRejected ? (
          <Typography variant="subtitle1" color="error.main">
            Already Rejected
          </Typography>
        ) : (
          <>
            <Button
              variant="contained"
              color="primary"
              sx={{ mr: 1 }}
              onClick={onApprove}
            >
              Approve
            </Button>
            <Button
              variant="outlined"
              color="error"
              onClick={() => dispatch(setRejectModalOpen(true))}
            >
              Reject
            </Button>
          </>
        )}
      </Box>
    </Box>
  );
};

export default ProofFooter;
